const routes =[

    /*
     * Legacy routes
     *
     * When converting existing routes to SSR, add them to this block.
     * When adding new pages and routes, add them to 'New Routes' section further down in this array.
     */
    {path: '/account/login', component: require('./pages/auth/Login.vue').default},
    {path: '/account/password/remind', component: require('./pages/auth/ResetPassword.vue').default},
    {path: '/account/password/reset/:userId/:token', component: require('./pages/auth/SetNewPassword.vue').default},
    {path: '/account/subscription/downgrade', component: require('./pages/downgrade/index.vue').default},
    {
        path: '/sign-up/thank-you',
        component: require('./pages/thank-you/Index.vue').default,
        alias: '/sign-up/thank-you/paid'
    },

    /*
     * New routes
     *
     * When adding new routes, add the them to this block.
     * When converting existing pages to SSR add them to 'Legacy routes' section at the start of this array.
     *
     * For new routes we want to follow Nuxt style routing (https://nuxtjs.org/guide/routing),
     * where the folder structure mirrors the routes.
     */
    {name: "team_invite", path: '/team-invite/:token', component: require('./pages/team-invite/_token/index.vue').default},
    {name: "team_invite_create", path: '/team-invite/:token/create-account', component: require('./pages/team-invite/_token/create-account.vue').default},
    {name: "team_invite_login", path: '/team-invite/:token/log-in', component: require('./pages/team-invite/_token/log-in.vue').default},
    {name: "team_invite_respond", path: '/team-invite/:token/respond', component: require('./pages/team-invite/_token/respond.vue').default},

    {path: '/account/team/details', component: require('./pages/account/team/Details').default},
    {path: '/account/team/invoices', component: require('./pages/account/team/Invoices').default},
    {path: '/account/team/manage-members', component: require('./pages/account/team/ManageMembers').default},

    {name: "license", path: '/license', component: require('./pages/license/Index').default},
]

export default routes;
